// EverythingRave How It Works page (Shopify). Same content as the Netlify funnel (ER-Site site/assets/js/funnel.js).
// Ad links open the right day: /pages/how-it-works?for=gym (or college, festival, work). #gym also works.
// Prices, variants and stock come live from Shopify through the erhiw-data block in sections/er-how-it-works.liquid.
(() => {
  const STORE = "";
  const DATA = JSON.parse(document.getElementById("erhiw-data").textContent);
  const PIXEL_ID = ""; // Shopify already runs the Meta Pixel through the Facebook and Instagram channel.
  const DEFAULT_PERSONA = "festival";

  // Prices and variant IDs checked against Shopify on 2026-10-03.
  // Shopify still uses the old product names and handles, so the links point at those handles.
  const PRODUCTS = {
    "amplified-lift":    { name: "Amplified Lift",     f: "wear",  price: 12,    was: 24,    variant: "46136102715586", handle: "rave-molli",         img: "amplified-lift",    data: "amplified-lift", line: "Energy, mood and focus. Contains caffeine and 5-HTP." },
    "awaken-lifted":     { name: "Awaken Lifted",      f: "wear",  price: 12,    was: 24,    variant: "45981835231426", handle: "dopa-lifted",        img: "awaken-lifted",     data: "dopa-lifted",    line: "Energy and alertness. Contains caffeine and 5-HTP." },
    "vitality-lifted":   { name: "Vitality Lifted",    f: "wear",  price: 12,    was: 24,    variant: "46136101404866", handle: "arousal-xtacy",      img: "vitality-lifted",   data: "vitality-lifted", line: "Built for training days. Caffeine free." },
    "recover-replenish": { name: "Recover Replenish",  f: "wear",  price: 12,    was: 24,    variant: "46136101503170", handle: "doperecover",        img: "recover-replenish", data: "dope-recover",   line: "Recovery. Caffeine free." },
    "zoomies":           { name: "Zoomies Energy Gum", f: "chew",  price: 16,    was: null,  variant: "46136102813890", handle: "zoomies-energy-gum", img: "zoomies",           data: "zoomies-energy-gum", line: "59 mg caffeine + B12. 16 pieces." },
    "swallow-liquid":    { name: "Swallow Liquid",     f: "drink", price: 19.95, was: 24.95, variant: "46321205838018", handle: "swallow-liquid-green-apple-energy", img: "swallow-liquid", data: "swallow-liquid", line: "Hydration, energy, immunity. 20 sticks." }
  };

  // Timeline copy from the approved draft. pct is where the node sits on the rail.
  const PERSONAS = {
    festival: { name: "Festival", head: "Doors at 3. Last set at 2.", sub: "A festival day is eleven hours on your feet, mostly in the sun. Here's how to pace it so you're still dancing at the closer.",
      note: "Amplified Lift contains 5-HTP. Do not combine it with antidepressants or anything else that affects serotonin. Drink water and take breaks.",
      nodes: [
        { t: "3:00 PM", ph: "BEFORE", p: "amplified-lift", pct: 6, title: "Patch on while you get ready", body: "Stick it on clean, dry skin before you head out. It releases slowly, so it keeps working in the background while you're in the crowd." },
        { t: "5:30 PM", ph: "DURING", p: "swallow-liquid", pct: 36, title: "Hydration while the sun's still out", body: "Mix a stick into your water bottle. You sweat out sodium and potassium all afternoon, and plain water doesn't put them back." },
        { t: "11:30 PM", ph: "DURING", p: "zoomies", pct: 68, title: "Second wind for the headliner", body: "One piece when the late set needs you. Fits in any pocket, no cooler or line required." },
        { t: "2:00 AM", ph: "AFTER", p: "recover-replenish", pct: 94, title: "Swap to recovery on the ride home", body: "Take off Amplified Lift and put on Recover Replenish. It's caffeine free, so you're not adding caffeine on the way to bed." }
      ] },
    gym: { name: "Gym", head: "Alarm at 5. Lift at 6. Full day after.", sub: "Training before work means your energy has to outlast the workout. Here's how to cover the session and everything after it.",
      nodes: [
        { t: "5:15 AM", ph: "BEFORE", p: "vitality-lifted", pct: 6, title: "Patch on before you leave", body: "Built for training days. L-Arginine and Ginkgo for circulation, Ashwagandha for drive. Put it on with your pre-gym routine and let it ride through the session." },
        { t: "7:00 AM", ph: "AFTER LIFT", p: "swallow-liquid", pct: 32, title: "Refill what you sweat out", body: "One stick in your shaker or bottle after the session. Sodium, potassium and magnesium leave with your sweat. This puts them back." },
        { t: "2:30 PM", ph: "DURING", p: "zoomies", pct: 64, title: "The afternoon dip", body: "Early alarms catch up with you mid-afternoon. One piece instead of a second scoop of pre-workout." },
        { t: "9:00 PM", ph: "WIND DOWN", p: "recover-replenish", pct: 94, title: "Recovery patch on training nights", body: "Caffeine free and made for bouncing back after hard sessions, so tomorrow starts from a better place." }
      ] },
    college: { name: "College", head: "8 AM lecture. Shift after. Paper due at midnight.", sub: "College days don't end when class does. Here's how to stay sharp from first lecture to last paragraph, without living on energy drinks.",
      note: "Awaken Lifted contains 5-HTP. Do not use it with antidepressants or anything else that affects serotonin.",
      nodes: [
        { t: "7:30 AM", ph: "BEFORE", p: "awaken-lifted", pct: 6, title: "Under your sleeve before class", body: "Nobody in lecture can see it. Steady energy for a morning of back-to-back classes, without the sugar of a can." },
        { t: "12:30 PM", ph: "DURING", p: "swallow-liquid", pct: 36, title: "Lunch, plus actual hydration", body: "Iced coffee isn't water. One stick in your bottle between classes keeps you hydrated through the afternoon." },
        { t: "6:30 PM", ph: "DURING", p: "zoomies", pct: 66, title: "One piece for the study session", body: "Paper, problem set, group project. One piece when you sit down. Try to keep caffeine at least six hours before you plan to sleep." },
        { t: "11:00 PM", ph: "AFTER", p: "recover-replenish", pct: 94, title: "Done for the day", body: "After a long shift or a late night, swap to the caffeine free recovery patch so you're not adding caffeine before bed." }
      ] },
    work: { name: "Work", head: "Back-to-back calls. Still sharp at 4.", sub: "Most workdays aren't one big push. They're eight hours of small ones. Here's how to stay on through the afternoon without the third coffee.",
      note: "Amplified Lift contains 5-HTP. Do not use it with antidepressants or anything else that affects serotonin.",
      nodes: [
        { t: "7:45 AM", ph: "BEFORE", p: "amplified-lift", pct: 8, title: "On with your morning routine", body: "Energy and focus that runs in the background, under a sleeve, through every meeting on the calendar." },
        { t: "10:30 AM", ph: "DURING", p: "swallow-liquid", pct: 46, title: "Upgrade the desk bottle", body: "Offices are dry and coffee isn't hydration. One stick mid-morning keeps you from fading by lunch." },
        { t: "2:30 PM", ph: "DURING", p: "zoomies", pct: 84, title: "The 2:30 slump", body: "One piece before the afternoon meeting. No coffee run needed, and zero calories." }
      ] }
  };

  const ICONS = {
    wear: '<svg viewBox="0 0 24 24"><rect x="4" y="7" width="16" height="10" rx="3"/><circle cx="9" cy="12" r="1"/><circle cx="15" cy="12" r="1"/></svg>',
    chew: '<svg viewBox="0 0 24 24"><rect x="5" y="8" width="14" height="8" rx="3"/><path d="M9 8v8M15 8v8"/></svg>',
    drink: '<svg viewBox="0 0 24 24"><path d="M12 3c3 4 6 7.5 6 11a6 6 0 0 1-12 0c0-3.5 3-7 6-11z"/></svg>'
  };
  const FNAME = { wear: "PATCH", chew: "GUM", drink: "HYDRATION STICK" };

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const money = (n) => "$" + (Number.isInteger(n) ? n : n.toFixed(2));
  const img = (k) => DATA.img[k] || "";
  // Live prices and handles from Shopify override the defaults above.
  for (const [k, live] of Object.entries(DATA.products || {})) {
    if (!PRODUCTS[k] || !live || !live.handle) continue;
    Object.assign(PRODUCTS[k], { handle: live.handle, price: Number(live.price), was: live.was ? Number(live.was) : null, variant: String(live.variant), available: live.available });
  }

  // Pass ad UTMs through to the store and tag the persona, so Shopify reports show which day sold.
  const incoming = new URLSearchParams(location.search);
  function utm(persona) {
    const q = new URLSearchParams();
    q.set("utm_source", incoming.get("utm_source") || "er-funnel");
    q.set("utm_medium", incoming.get("utm_medium") || "landing");
    q.set("utm_campaign", incoming.get("utm_campaign") || "educational-funnel");
    q.set("utm_content", persona || "none");
    for (const k of ["utm_term", "fbclid", "ttclid"]) if (incoming.get(k)) q.set(k, incoming.get(k));
    return q.toString();
  }
  const productUrl = (k) => `/products/${PRODUCTS[k].handle}`;
  // Cart permalink: adds every item and opens checkout. Buy 2 Get 1 Free on patches applies there automatically.
  // Each day has its own kit product in Shopify (a linked bundle, so stock comes off each item automatically).
  // Kit prices match buying every item at the current sale price.
  const KITS = { festival: "festival-kit", gym: "gym-kit", college: "college-kit", work: "work-kit" };
  const kitUrl = () => `/products/${(DATA.kits[cur] && DATA.kits[cur].handle) || KITS[cur]}`;
  const track = (event, params) => { if (window.fbq) window.fbq("trackCustom", event, params); };

  /* ---------- your day timeline ---------- */
  const trackEl = $("#track"), fill = $("#fill"), rider = $("#rider"), day = $("#day");
  const nodeEls = [];
  for (let i = 0; i < 4; i++) {
    const b = document.createElement("button");
    b.className = "node"; b.type = "button"; b.setAttribute("role", "tab"); b.dataset.i = i;
    b.innerHTML = '<span class="t"></span><span class="dot"></span><span class="ph"></span>';
    b.addEventListener("click", () => pick(i));
    trackEl.appendChild(b); nodeEls.push(b);
  }
  let cur = null, curNode = 0;

  const words = (el, txt) => { el.innerHTML = txt.split(" ").map((w, i) => `<span class="w" style="--i:${i}">${esc(w)}</span>`).join(" "); };

  function setP(key, opts = {}) {
    const p = PERSONAS[key]; if (!p) return;
    cur = key;
    $$(".chip, .pick button").forEach((c) => c.setAttribute("aria-selected", String(c.dataset.p === key)));
    words($("#p-head"), p.head);
    $("#p-sub").textContent = p.sub;
    nodeEls.forEach((n, i) => {
      const d = p.nodes[i];
      if (!d) { n.classList.add("off"); return; }
      const f = PRODUCTS[d.p].f;
      n.classList.remove("off"); n.style.left = d.pct + "%"; n.style.setProperty("--c", `var(--${f})`);
      $(".t", n).textContent = d.t; $(".ph", n).textContent = d.ph; $(".dot", n).innerHTML = ICONS[f];
      n.setAttribute("aria-label", `${d.t}, ${d.title}`);
    });
    const note = $("#p-note"); note.hidden = !p.note; note.textContent = p.note || "";

    // kit
    const keys = [...new Set(p.nodes.map((d) => d.p))];
    const kit = DATA.kits[key] || {};
    const total = kit.price ? Number(kit.price) : keys.reduce((a, k) => a + PRODUCTS[k].price, 0);
    const was = kit.was ? Number(kit.was) : keys.reduce((a, k) => a + (PRODUCTS[k].was || PRODUCTS[k].price), 0);
    const patches = keys.filter((k) => PRODUCTS[k].f === "wear").length;
    const href = kitUrl(keys);
    $("#kit-name").textContent = `YOUR ${p.name.toUpperCase()} KIT`;
    const kimg = $("#kit-img"); if (kimg && DATA.kitimg && DATA.kitimg[key]) { kimg.src = DATA.kitimg[key]; kimg.alt = `${p.name} kit in the Everything Rave shadow box`; }
    $("#kit-items").innerHTML = keys.map((k) => `<a class="kchip" href="${productUrl(k)}" data-track="product" data-product="${k}"><img src="${img(k)}" alt="" width="28" height="28">${esc(PRODUCTS[k].name)} · ${money(PRODUCTS[k].price)}${PRODUCTS[k].was ? ` <s>${money(PRODUCTS[k].was)}</s>` : ""}</a>`).join("");
    $("#kit-total").innerHTML = `<small>KIT TOTAL</small>${money(total)}${was > total ? ` <s>${money(was)}</s>` : ""}`;
    $("#kit-fine").textContent = "One kit, one price. Same as buying each item at today's sale price, packed and shipped together.";
    for (const id of ["kit-cta", "final-cta", "sticky-cta"]) { const a = $("#" + id); a.href = href; }
    $("#kit-cta").textContent = `ADD THE ${p.name.toUpperCase()} KIT`;
    $("#final-cta").textContent = `ADD THE ${p.name.toUpperCase()} KIT`;
    $("#sticky-cta").textContent = innerWidth < 640 ? "ADD KIT" : `ADD THE ${p.name.toUpperCase()} KIT`;
    $("#sticky-lbl").innerHTML = `${esc(p.name.toUpperCase())} KIT<small>${keys.length} products · ${money(total)}</small>`;
    $("#final-head").textContent = `Ready for your ${p.name.toLowerCase()} day?`;

    if (opts.animate) { day.classList.remove("swap", "beam"); void day.offsetWidth; day.classList.add("swap", "beam"); }
    if (opts.updateUrl) { try { const u = new URL(location.href); u.searchParams.set("for", key); u.hash = ""; history.replaceState(null, "", u.pathname + u.search); } catch {} }
    if (opts.scroll) $("#your-day").scrollIntoView({ behavior: opts.instant ? "auto" : "smooth", block: "start" });
    if (!opts.silent) track("FunnelPersona", { persona: key });
    pick(0);
  }

  function pick(i) {
    const d = PERSONAS[cur].nodes[i]; if (!d) return;
    curNode = i;
    const pr = PRODUCTS[d.p];
    nodeEls.forEach((n, j) => n.setAttribute("aria-selected", String(j === i)));
    rider.style.left = d.pct + "%"; fill.style.width = d.pct + "%";
    const m = $("#moment"); m.style.setProperty("--c", `var(--${pr.f})`);
    $("#m-when").textContent = `${d.ph} · ${d.t}`;
    $("#m-title").textContent = d.title;
    $("#m-body").textContent = d.body;
    const pl = $("#m-prod");
    pl.style.setProperty("--c", `var(--${pr.f})`); pl.href = productUrl(d.p); pl.dataset.product = d.p;
    pl.innerHTML = `<img src="${img(d.p)}" alt="" width="44" height="44"><span>${esc(pr.name)}<small>${money(pr.price)}${pr.was ? ` · was ${money(pr.was)}` : ""}</small></span>`;
    const w = $("#m-what"); w.dataset.f = pr.f; w.textContent = `WHAT'S A ${FNAME[pr.f]}? ↑`;
    m.classList.remove("swap"); void m.offsetWidth; m.classList.add("swap");
  }

  trackEl.addEventListener("keydown", (e) => {
    const n = PERSONAS[cur].nodes.length;
    if (e.key === "ArrowRight") { pick((curNode + 1) % n); nodeEls[curNode].focus(); }
    if (e.key === "ArrowLeft") { pick((curNode - 1 + n) % n); nodeEls[curNode].focus(); }
  });

  /* ---------- formats tabs + animation loops ---------- */
  function loadVideo(panel) {
    const v = $("video", panel); if (!v || v.dataset.tried) return;
    v.dataset.tried = "1";
    v.addEventListener("loadeddata", () => { v.closest(".anim").classList.add("has-video"); v.play().catch(() => {}); }, { once: true });
    v.preload = "auto";
    v.src = v.dataset.src; // a missing file just errors and the drawn diagram stays
    v.play().catch(() => {});
  }
  function setF(f, scroll) {
    $$(".seg button").forEach((b) => b.setAttribute("aria-selected", String(b.dataset.f === f)));
    $$(".fmt").forEach((p) => {
      const on = p.dataset.panel === f; p.hidden = !on;
      const v = $("video", p);
      if (on) { p.classList.remove("swap"); void p.offsetWidth; p.classList.add("swap"); loadVideo(p); if (v && v.src) v.play().catch(() => {}); }
      else if (v) v.pause();
    });
    $$(".more[open]").forEach((d) => { d.open = false; });
    if (scroll) $(".seg").scrollIntoView({ behavior: "smooth", block: "start" });
  }
  $$(".seg button").forEach((b) => b.addEventListener("click", () => setF(b.dataset.f)));
  $$("[data-goto]").forEach((a) => a.addEventListener("click", (e) => { e.preventDefault(); setF(a.dataset.goto, true); }));
  $("#m-what").addEventListener("click", function () { setF(this.dataset.f, true); });
  if ("IntersectionObserver" in window) {
    new IntersectionObserver((es) => { if (es[0].isIntersecting) loadVideo($(".fmt:not([hidden])")); }, { rootMargin: "200px" }).observe($("#formats"));
  }

  /* ---------- product details from products.json (same source as the Products page) ---------- */
  function fillProducts(data) {
    const by = Object.fromEntries(((data && data.products) || []).map((x) => [x.slug, x]));
    $("#patchLineup").innerHTML = ["amplified-lift", "awaken-lifted", "vitality-lifted", "recover-replenish"].map((k) => {
      const x = by[PRODUCTS[k].data];
      return `<a href="${productUrl(k)}" data-track="product" data-product="${k}" style="--c:var(--wear)"><img src="${img(k)}" alt="${esc(PRODUCTS[k].name)} pack" width="160" height="200" loading="lazy"><b>${esc(PRODUCTS[k].name.toUpperCase())}</b><span>${esc(PRODUCTS[k].line)}</span>${x ? `<span class="ing">${esc(x.ingredients.join(", "))}</span>` : ""}</a>`;
    }).join("");
    $$(".ticker .row").forEach((r) => {
      const x = by[r.dataset.from]; if (!x) { r.closest(".ticker").hidden = true; return; }
      const items = (x.supplementFacts && x.supplementFacts.length) ? x.supplementFacts.map(([a, b]) => `${a.replace(/\s*\(.*?\)\s*/g, " ").trim()} ${b}`) : x.ingredients;
      const h = items.map((s) => `<span>${esc(s)}</span>`).join("");
      r.innerHTML = h + h;
    });
    $$("a.pack").forEach((a) => {
      const k = a.dataset.pack, pr = PRODUCTS[k];
      a.href = productUrl(k); a.dataset.track = "product"; a.dataset.product = k;
      a.innerHTML = `<img src="${img(k)}" alt="${esc(pr.name)} pack" width="84" height="105" loading="lazy"><div><b>${esc(pr.name.toUpperCase())} · ${money(pr.price)}</b><span>${esc(pr.line)}</span></div>`;
    });
  }

  /* ---------- sticky bar: after the hero, hidden at the final CTA ---------- */
  if ("IntersectionObserver" in window) {
    const st = { hero: true, final: false };
    const upd = () => $("#sticky").classList.toggle("show", !st.hero && !st.final);
    new IntersectionObserver((es) => { st.hero = es[0].isIntersecting; upd(); }).observe($(".hero"));
    new IntersectionObserver((es) => { st.final = es[0].isIntersecting; upd(); }, { threshold: 0.3 }).observe($(".final"));
  } else $("#sticky").classList.add("show");

  /* ---------- clicks + tracking ---------- */
  $$(".chip").forEach((c) => c.addEventListener("click", () => setP(c.dataset.p, { animate: true, updateUrl: true })));
  $$(".pick button").forEach((c) => c.addEventListener("click", () => setP(c.dataset.p, { animate: true, updateUrl: true, scroll: true })));
  document.addEventListener("click", (e) => {
    const a = e.target.closest("a[data-track]");
    if (a) track(a.dataset.track === "stack" ? "FunnelKitClick" : "FunnelProductClick", { persona: cur, product: a.dataset.product || "" });
  });

  (function loadPixel() {
    if (!PIXEL_ID) return;
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  })();

  /* ---------- start: ad links jump straight to the right day ---------- */
  function personaFromUrl() {
    const q = (incoming.get("for") || incoming.get("persona") || "").toLowerCase();
    const path = ((location.pathname.match(/\/funnel\/([a-z-]+)/i) || [])[1] || "").toLowerCase();
    const hash = location.hash.replace(/^#(for-)?/, "").toLowerCase();
    return [q, path, hash].find((x) => PERSONAS[x]) || null;
  }
  const start = personaFromUrl();
  setP(start || DEFAULT_PERSONA, { silent: !start });
  if (start) {
    track("FunnelPersona", { persona: start, entry: true });
    setTimeout(() => $("#your-day").scrollIntoView({ behavior: "smooth", block: "start" }), 500);
  }
  fillProducts({ products: Object.entries(DATA.ingredients || {}).map(([slug, x]) => ({ slug, ...x })) });

  // Kit buttons add the kit straight to the cart, then open the cart. If that fails they fall back to the kit page.
  document.addEventListener("click", async (e) => {
    const a = e.target.closest("#kit-cta, #final-cta, #sticky-cta");
    if (!a || !cur) return;
    const kit = DATA.kits[cur];
    if (!kit || !kit.variant || kit.available === false) return;
    e.preventDefault();
    a.setAttribute("aria-busy", "true");
    try {
      const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(kit.variant), quantity: 1 }] }) });
      if (!r.ok) throw new Error("add failed");
      location.href = "/cart";
    } catch { location.href = a.href; }
  });
})();
